export const FIELD_VALIDATIONS = {
  city: 'required|noEmoji|noDoubleQuotes|max:40',
  postalCode: 'required|noEmoji|max:20',
  taxId: 'noEmoji|max:25',
};
